import { computed, Injectable, linkedSignal, Signal, signal, WritableSignal } from '@angular/core';
import { Rule } from '../models/types/Rule/Rule.type';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SidenavService {

  private _opened: WritableSignal<boolean> = signal(false);
  public opened: Signal<boolean> = linkedSignal(() => this._opened());

  private _rule: WritableSignal<Rule | undefined> = signal(undefined);
  public rule: Signal<Rule | undefined> = linkedSignal(() => this._rule());

  constructor(private readonly router: Router) {
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
    ).subscribe(() => {
      if (this._opened()) {
        this.close();
      }
    });
  }

  open(): void {
    this._opened.set(true);
  }

  close(): void {
    this._opened.set(false);
  }

  toggle(): void {
    this.opened() ? this.close() : this.open();
  }

  selectRule(rule: Rule) {
    this._rule.set(rule);
  }

  resetRuleRule() {
    this._rule.set(undefined);
  }

  isOtherLink(name: string): boolean {
    return name.trim().toLowerCase() === "other";
  }

}
